import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { validateEmail } from "@/lib/email";
import { toast } from "sonner";

export default function ResetRequest() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [emailError, setEmailError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const emailErr = validateEmail(email);
    if (emailErr) { setEmailError(emailErr); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-request", { email });
      setSent(true);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-lv-bg flex items-center justify-center px-6" data-testid="reset-request-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <Link to="/" className="font-serif text-2xl text-cream tracking-[0.25em]">LV PASS</Link>
          <p className="text-xs tracking-[0.3em] uppercase text-lv-muted mt-4">Reset Password</p>
        </div>
        {sent ? (
          <div className="text-center space-y-4" data-testid="reset-request-sent">
            <p className="text-cream text-sm tracking-wide leading-relaxed">
              If an account with that email exists, we've sent a password reset link. Please check your inbox.
            </p>
            <Link to="/auth/sign-in" className="lv-btn-secondary inline-block mt-6 min-h-[44px] leading-[44px]">Back to Sign In</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-xs tracking-[0.2em] uppercase text-lv-muted mb-2" htmlFor="reset-email">Email</label>
              <input id="reset-email" type="text" inputMode="email" autoComplete="email" value={email} onChange={(e) => { setEmail(e.target.value); setEmailError(null); }} className={`lv-input${emailError ? " border-red-500/70" : ""}`} placeholder="your@email.com" required data-testid="reset-request-email" />
              {emailError && <p className="text-xs text-red-400 mt-1.5 leading-relaxed" data-testid="reset-email-error">{emailError}</p>}
            </div>
            <button type="submit" disabled={loading} className="lv-btn-primary w-full min-h-[48px]" data-testid="reset-request-submit">
              {loading ? "Sending\u2026" : "Send Reset Link"}
            </button>
            <div className="text-center mt-6">
              <Link to="/auth/sign-in" className="text-sm text-lv-muted hover:text-bronze transition-colors tracking-wide">Back to Sign In</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
